module.exports = __webpack_public_path__ + "static/media/certificado.8d55aba5.png";